export default class BriefCaseItemsNumber {
    constructor() {

        this.briefCaseItemsNumberEls = document.querySelectorAll(".briefcase-items-number");
        if (this.briefCaseItemsNumberEls.length === 0) {
            return;
        }

        this.onBriefCaseItemsChanged(this.briefCaseItemsNumberEls);

        document.addEventListener('briefCaseItemsChanged', () => {
            this.onBriefCaseItemsChanged(this.briefCaseItemsNumberEls);
        });

    }

    onBriefCaseItemsChanged(briefCaseItemsNumberEls = []) {
        briefCaseItemsNumberEls.forEach(briefCaseItemsNumberEl => {
            this.briefCaseItemsNumberAmountEl = briefCaseItemsNumberEl.querySelector(".briefcase-items-number__amount");
            if (!this.briefCaseItemsNumberAmountEl) {
                return;
            }

            this.briefCaseItemsNumber = JSON.parse(localStorage.getItem('briefCaseItems')) ? JSON.parse(localStorage.getItem('briefCaseItems')).length : 0;
            this.briefCaseItemsNumberAmountEl.innerHTML = this.briefCaseItemsNumber + " Items";
        });
    }
}